var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgPoweroff = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M3.333 7.333h5.334v1.333H3.333v2L0 8l3.333-2.667v2ZM2.666 12h1.806a5.333 5.333 0 1 0 0-8H2.666a6.667 6.667 0 1 1 0 8Z", fill: "#EC7057" }));
export { SvgPoweroff as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMuMzMzIDcuMzMzaDUuMzM0djEuMzMzSDMuMzMzdjJMMCA4bDMuMzMzLTIuNjY3djJaTTIuNjY2IDEyaDEuODA2YTUuMzMzIDUuMzMzIDAgMSAwIDAtOEgyLjY2NmE2LjY2NyA2LjY2NyAwIDEgMSAwIDhaIiBmaWxsPSIjRUM3MDU3Ii8+PC9zdmc+";
